import React, { Component, type JSX } from 'react';
import { price } from '../../util/price.function';

interface CartItemProps {
  id: string;
  title: string;
  subtitle?: string;
  label?: string;
  price: string;
  deleteMethod: (id: string) => Promise<void>;
}

interface CartItemState {
  deleting: boolean;
}

/**
 * Render the items the in cart icon. Show a small spinning
 * icon when removing an item from the cart.
 */
export class CartItem extends Component<CartItemProps, CartItemState> {

  constructor(props: CartItemProps) {
    super(props);

    this.state = {
      deleting: false,
    };
  }

  // set state to deleting and call parent callback
  public onRemoveCartItem(): void {
    this.setState({ deleting: true });
    this.props.deleteMethod(this.props.id);
  }

  public render(): JSX.Element {
    const props = this.props;

    // if the user is deleting the item show a loader
    const deleteIcon = this.state.deleting === true
      ? (<i className="fa fa-circle-o-notch fa-spin"/>)
      : (<i className="fa fa-times"/>) ;

    return (
      <li className="shopping-cart-icon__list-item">
        <div className="shopping-cart-icon__list-item-body">
          <div className="shopping-cart-icon__list-item-title">
            {props.title}
          </div>
          <div className="shopping-cart-icon__list-item-subtitle">
            { props.subtitle }
          </div>
          <div className="shopping-cart-icon__list-item-label">
            { props.label }
          </div>
        </div>
        <div className="shopping-cart-icon__list-item-price">
          <a className="shopping-cart-icon__item-remove"
            onClick={(): void => this.onRemoveCartItem()}>
            {deleteIcon}
          </a>
          <div className="shopping-cart-icon__list-item-amount">
            &euro; { price(props.price) }
          </div>
        </div>
      </li>
    );
  }
}
